/** Types */
export type UserChoiceFlag = (typeof userChoiceFlags)[keyof typeof userChoiceFlags];


/**
 * Flags to track user choices that we want to prompt them for only once.
 * For example, if we want to prompt the user to select a theme on their first visit, we can use the `hasSelectedTheme`
 * flag to track whether they have made a selection or not.
 * This way, we can avoid prompting them again in the future.
 */
export const userChoiceFlags = {
    hasSelectedTheme: 'hasSelectedTheme',
} as const;
